<template>
  <teleport v-if="isMounted" to="#tools">
    <div class="flex items-center gap-5 px-4 border-b border-gray-200 h-11">

      <button data-testid="device-refresh-button" type="button" class="inline-flex items-center p-1 text-gray-700 border border-transparent rounded-full hover:bg-gray-50 focus:outline-none" @click="refreshDevice">
        <RefreshIcon :class="[deviceLoading ? 'animate-reverse-spin' : '', 'h-5 w-5']" aria-hidden="true" />
      </button>
      <button v-if="isSuperAdmin" type="button" class="hidden inline-flex items-center px-2.5 py-1.5 border border-gray-300 shadow-sm text-xs font-medium rounded text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500" @click="showCopyConfig = true">
        {{ $t("device.action.copyConfig") }}
      </button>
      <!-- <button v-if="isSuperAdmin" type="button" class="inline-flex items-center px-2.5 py-1.5 border border-gray-300 shadow-sm text-xs font-medium rounded text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500" @click="showEditOwner = true">
        {{ $t("device.action.changeOwner") }}
      </button> -->
      <button v-if="isSuperAdmin" data-testid="device-apply-config-template-button" type="button" class="inline-flex items-center px-2.5 py-1.5 border border-gray-300 shadow-sm text-xs font-medium rounded text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500" @click="showApplyConfigTemplate = true">
        {{ $t("device.action.applyConfigTemplate") }}
      </button>
      <button v-if="isSuperAdmin" data-testid="device-reboot-button" type="button" class="inline-flex items-center px-2.5 py-1.5 border border-gray-300 shadow-sm text-xs font-medium rounded text-red-700 bg-white hover:bg-red-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500" @click="showRebootDevice = true">
        {{ $t("device.action.reboot") }}
      </button>
    </div>
  </teleport>
  <DeviceSettingTabs :device-id="deviceId" v-if="isSuperAdmin" />
  <router-view></router-view>
  <DeviceCopyConfigSlide :open="showCopyConfig" @cancel="showCopyConfig = false" />
  <DeviceEditOwnerSlide :open="showEditOwner" :deviceId="device.id" @cancel="flushDevice(); showEditOwner = false;" />
  <ApplyConfigTemplate :open="showApplyConfigTemplate" @cancel="showApplyConfigTemplate = false"></ApplyConfigTemplate>
  <RebootDevice :open="showRebootDevice" @cancel="showRebootDevice = false"></RebootDevice>

</template>

<script>
import { RefreshIcon } from "@heroicons/vue/outline";
import DeviceSettingTabs from "@/components/DeviceSettingTabs.vue";
import { computed, onMounted, ref, watch } from "vue";
import DeviceCopyConfigSlide from "@/views/DeviceCopyConfigSlide";
import DeviceEditOwnerSlide from "@/components/DeviceEditOwnerSlide";
import ApplyConfigTemplate from "@/components/modals/ApplyConfigTemplate";
import RebootDevice from "@/components/modals/RebootDevice";
import { useStore } from "vuex";
import i18n from "@/i18n";
import { SIMPLE_MODE_EVENT_TYPES } from "@/lib/alarms";

export default {
  components: {
    DeviceCopyConfigSlide,
    DeviceEditOwnerSlide,
    DeviceSettingTabs,
    RefreshIcon,
    ApplyConfigTemplate,
    RebootDevice
  },
  props: ["deviceId"],
  setup() {
    const alertOpen = ref(false);
    const showCopyConfig = ref(false);
    const showEditOwner = ref(false);
    const showApplyConfigTemplate = ref(false);
    const showRebootDevice = ref(false);
    const isMounted = ref(false);
    const store = useStore();

    const isSuperAdmin = computed(() => {
      return store.getters["auth/isSuperAdmin"];
    });
    const device = computed(() => store.state.device.current);
    const deviceLoading = computed(
      () => store.state.device.loading || store.state.device.loadingAggregations
    );

    watch(() => device.value.owner?.id, (ownerId) => {
      if (isSuperAdmin.value && ownerId) {
        store.dispatch("device/queryConfigTemplates");
      }
    }, { immediate: true });

    onMounted(() => {
      isMounted.value = true;
    })

    const flushDevice = async () => {
      store.dispatch("device/setLoading", true)
      const serialNumber = store.state.device.current.serialNumber;
      await new Promise((resolve) => setTimeout(resolve, 5500));
      await store.dispatch("device/reloadDevice", serialNumber);
      window.location.reload();
    }

    const refreshDevice = async () => {
      const serialNumber = store.state.device.current.serialNumber;
      store.dispatch("device/getAggregations", { refresh: true });
      store.dispatch('device/getDeviceEvents', {
        deviceId: store.state.device.current.id,
        reload: true,
        eventTypes: SIMPLE_MODE_EVENT_TYPES
      });
      await store.dispatch("device/reloadDevice", serialNumber);

      store.commit("showNotification", {
        title: i18n.global.t('notification.deviceRefresh', { serialNumber: serialNumber }),
        type: "info",
      });

    };

    return {
      isMounted,
      alertOpen,
      isSuperAdmin,
      showCopyConfig,
      showEditOwner,
      showApplyConfigTemplate,
      showRebootDevice,
      deviceLoading,
      device,
      refreshDevice,
      flushDevice,
    };
  },
};
</script>
